import React, { useEffect, useState } from "react";
import Avatar from "react-avatar";
import AudioRec from "../components/Knowledge/CreateKnowledge/AudioRec";
import UploadDocument from "../components/Knowledge/CreateKnowledge/UploadDocument";
// import BulkUploadDocument from "../components/Knowledge/CreateKnowledge/BulkUploadDocument";
import VideoRec from "../components/Knowledge/CreateKnowledge/VideoRec";
import AskQuery from "../components/QAndA/AskAnExpert/AskQuery";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import * as images from "../constants/Images";
import { toast } from "react-toastify";
import { decryptV2 } from "../helpers/Cryptography/CryptoV2";
import { getFromEncLocalStorage } from "../helpers/Utils/Utils";

function ShareLearnings() {
  const { progressStatus } = useSelector((state) => state.progReducer);
  const { progressStatusAudio } = useSelector(
    (state) => state.progReducerAudio
  );
  const [empName, setName] = useState("");
  const [uploadDoc, setUploadDoc] = useState(false);
  // const [bulkUploadDoc, setBulkUploadDoc] = useState(false);
  const [recAudio, setRecAudio] = useState(false);
  const [recVideo, setRecVideo] = useState(false);
  const [uploadQue, setUploadQue] = useState(false);

  const [val, setVal] = useState(1);

  const isAdmin = decryptV2(getFromEncLocalStorage("ggwp") || "");

  useEffect(() => getDetails(), []);

  const getDetails = async () => {
    let firstName = await getFromEncLocalStorage("firstname");
    let lastName = await getFromEncLocalStorage("lastname");
    let name = firstName + " " + lastName;

    setName(name);
  };

  return (
    <div className="card home-card ">
      <div
        className="display-row justify-space-between align-items-center"
        style={{ padding: "5px 8px", fontWeight: "bold" }}
      >
        <div style={{ paddingTop: "5px" }}>
          <Avatar name={empName} size="35px" round={true} />
          <span
            className="card-text"
            style={{
              margin: "auto",
              paddingLeft: "4px",
              fontSize: "12px",
            }}
          >
            Share your learnings...
          </span>
        </div>
        <div
          style={{ cursor: "pointer", fontSize: "10px" }}
          onClick={() => {
            setUploadDoc(true);
            setRecAudio(false);
            setRecVideo(false);
            setUploadQue(false);
            // setUploadDoc(true);
            // setBulkUploadDoc(false);
            setVal(val + 1);
          }}
        >
          <img src={images.docs_upload} className="header-navimg-du" />
          <span className="header-text">
            Document
            <br /> upload
          </span>
        </div>
        {/* {uploadDoc && (
          <div
            className="modal fade "
            id="docUpload"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            aria-labelledby="addInterestsLabel"
            aria-hidden="true"
          >
            <UploadDocument />
          </div>
        )} */}
        {uploadDoc && <UploadDocument handleModal={setUploadDoc} />}
        <div
          style={{ cursor: "pointer", fontSize: "10px" }}
          onClick={() => {
            if (progressStatus === 0 || progressStatus === 100) {
              setUploadDoc(false);
              setRecAudio(false);
              setRecVideo(true);
              setUploadQue(false);
              // setBulkUploadDoc(false);
              setVal(val + 1);
            } else {
              toast("Uploading video in progress.");
            }
          }}
        >
          <img src={images.video_rec} className="header-navimg-av" />
          <span className="header-text">
            Record
            <br /> Video
          </span>
        </div>

        {recVideo && <VideoRec handleModal={setRecVideo} />}

        <div
          style={{ cursor: "pointer", fontSize: "10px" }}
          onClick={() => {
            if (progressStatusAudio === 0 || progressStatusAudio === 100) {
              setUploadDoc(false);
              setRecAudio(true);
              setRecVideo(false);
              setUploadQue(false);
              // setBulkUploadDoc(false);
              setVal(val + 1);
            } else {
              toast("Uploading audio in progress.");
            }
          }}
        >
          <img src={images.audio_rec} className="header-navimg-av" />
          <span className="header-text">
            Record
            <br /> Audio
          </span>
        </div>
        {recAudio && <AudioRec handleModal={setRecAudio} />}
        <div
          style={{ cursor: "pointer", fontSize: "10px" }}
          onClick={() => {
            setUploadDoc(false);
            setRecAudio(false);
            setRecVideo(false);
            setUploadQue(true);
            // setBulkUploadDoc(false);
            setVal(val + 1);
          }}
        >
          <img src={images.ask_expert_active} className="header-navimg-ae" />
          <span className="header-text">
            Ask
            <br /> an expert
          </span>
        </div>

        {uploadQue && <AskQuery handleModal={setUploadQue} />}

        {isAdmin == "true" || isAdmin == true ? (
          <div style={{ cursor: "pointer", fontSize: "10px" }}>
            <Link to="/bulk-upload-document">
              <img src={images.docs_upload} className="header-navimg-du" />
              <figcaption
                style={{ color: "black", textAlign: "center" }}
                className="header-text"
              >
                Bulk
                <br /> upload
              </figcaption>
            </Link>
          </div>
        ) : null}

        {/* {bulkUploadDoc && <BulkUploadDocument handleModal={setBulkUploadDoc} />} */}
      </div>
    </div>
  );
}

export default ShareLearnings;
